import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Grid } from '@material-ui/core';
import InfoComponent from '../components/loginPortal/NossaTecnologia'
import SectionLogin from '../components/loginPortal/sectionLogin/SectionLogin';
import BackGroundCard from '../components/loginPortal/BackGroundCard'

const LoginPortal = () => {
  const theme = useContext(ThemeContext)

  return (
    <Grid container direction='column'>
      <SectionLogin />
      <BackGroundCard />
      <InfoComponent />
    </Grid>

  );
};

export default LoginPortal;
